import React, { Fragment, useState } from "react";
import styled from "styled-components";
import media from "cssMix/index";
import cx from "classnames";
// comp
import ReactModal from "Components/common/ReactModal";
import Loading from "Components/common/Loading";
import { gameClickCount } from "api";

export default function PopModal({
  gameUrl,
  modalData,
  closeGameModal,
  handleHeartClick,
  handleOpenGame,
  favorite_game,
  t,
  gamePopup,
  lang,
}) {
  return (
    <ReactModal isOpen={gamePopup} onModalClose={closeGameModal}>
      <PopGame
        modalData={modalData}
        handleHeartClick={handleHeartClick}
        handleOpenGame={handleOpenGame}
        favorite_game={favorite_game}
        t={t}
        gameUrl={gameUrl}
        lang={lang}
      />
    </ReactModal>
  );
}

function PopGame({
  handleHeartClick,
  modalData,
  handleOpenGame,
  favorite_game,
  t,
  gameUrl,
  lang,
}) {
  const icon = modalData.icon;
  const type = modalData.type;
  const name = modalData.name;
  // const isFavorite = favorite_game.includes(modalData.game_id) || false
  const game_id = modalData.game_id;
  const [isFavorite, setIsFavorite] = useState(
    favorite_game.includes(modalData.game_id)
  );
  const source = modalData.source;
  const gaClass = {
    normal: "gav2_gameplay_general",
    featured: "gav2_gameplay_featured",
  };
  return (
    <PopGameBox>
      {!gameUrl && <Loading />}
      {gameUrl && (
        <Fragment>
          <div
            class={cx([
              "heart bx bxs-heart",
              { focus: isFavorite, ga_favorite: !isFavorite },
            ])}
            onClick={(e) => {
              handleHeartClick(e, game_id, isFavorite) && e.stopPropagation();
              setIsFavorite(!isFavorite);
            }}
            ga-gameid={game_id}
          />
          <img alt="" className="icon" src={icon} />
          <span className="gameTitle">{name}</span>
          <span className="gameType">{type}</span>
        </Fragment>
      )}
      <a
        href={gameUrl ? gameUrl : ""}
        target="_blank"
        rel="noopener noreferrer"
        className={`button ${gameUrl ? "highlight" : "lowlight"} ${
          gaClass[source]
        }`}
        ga-gameid={game_id}
        onClick={(e) => {
          const timeout = setTimeout(() => {
            gameClickCount({ gamecode: game_id, lang: lang });
            handleOpenGame(e);
            return () => clearTimeout(timeout);
          }, 100);
        }}
      >
        {gameUrl && t("enterGame")}
      </a>
    </PopGameBox>
  );
}

const PopGameBox = styled.div`
  width: 280px;
  height: 267px;
  z-index: 110;
  background: #ffffff;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  flex-direction: column;
  box-sizing: border-box;
  a {
    display: block;
    color: inherit;
    text-decoration: none;
  }
  & .heart {
    position: absolute;
    font-size: 22px;
    top: 22px;
    right: 22px;
    color: #b8c2d2;
    cursor: pointer;
    &.focus {
      color: #f4265a;
    }
  }
  .icon {
    margin-top: 12px;
    width: 120px;
    height: 120px;
  }

  .gameTitle {
    margin-top: 12px;
    color: #141620;
    font-size: 22px;
  }

  .gameType {
    font-size: 14px;
    font-weight: 500;
    color: #b8c2d2;
  }
  & .button {
    cursor: pointer;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45px;
    border-radius: 0 0 8px 8px;
    background-image: linear-gradient(99deg, #fbc500, #ef7a00 100%);
    &.lowlight {
      background-image: none;
      background-color: #b8c2d2;
    }
    &.highlight:hover {
      transition: all 0.3s ease 0s;
      box-shadow: rgb(253 120 55 / 50%) 0px 5px 15px 0px;
    }
  }
  ${media.mobile`
    width:80%;
  `}
`;
